export const CAL_LINK = 'samia-systems-rdkgv9/30min';
// The introductions funnel books a separate 20-minute intro call, with none of
// the diagnostic qualification questions attached.
export const INTRO_CAL_LINK = 'samia-systems-rdkgv9/intro-call-with-yussef';

export const INTEREST_OPTIONS = [
  { value: 'Corporate training', label: 'Corporate training' },
  { value: 'Custom AI development', label: 'Custom AI development' },
  {
    value: 'Affiliates, partnerships and Collabration',
    label: 'Affiliates, partnerships and collaboration',
  },
  { value: 'Other', label: 'Other' },
] as const;

export type Interest = (typeof INTEREST_OPTIONS)[number]['value'];

export type QualificationAnswers = {
  interest: Interest;
  projectBudgetUsd: number;
  monthlyRevenueUsd: number;
};

const CONSULTATION_INTERESTS = new Set<Interest>([
  'Custom AI development',
  'Affiliates, partnerships and Collabration',
]);

const PROJECT_BUDGET_THRESHOLD_USD = 1_000;
const MONTHLY_REVENUE_THRESHOLD_USD = 3_000;

export function isInterest(value: string): value is Interest {
  return INTEREST_OPTIONS.some((option) => option.value === value);
}

export function isQualifiedLead({
  interest,
  projectBudgetUsd,
  monthlyRevenueUsd,
}: QualificationAnswers): boolean {
  return (
    CONSULTATION_INTERESTS.has(interest) &&
    projectBudgetUsd > PROJECT_BUDGET_THRESHOLD_USD &&
    monthlyRevenueUsd > MONTHLY_REVENUE_THRESHOLD_USD
  );
}
